import DeliveryDatePicker from "components/Date/DeliveryDatePicker"
import React, { Component } from "react"
import {observer} from "mobx-react"
import { Link } from "react-router-dom"
import {
  Card,
  Col,
  FormField,
  FormInput,
  FormSelect,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from "elemental-react16"
import { Header, Button } from "semantic-ui-react"
import shop from "shop/shop"
import HeaderCheckout from "pages/checkout/HeaderCheckout"
import moment from "moment"

window.moment = moment
import "style/DeliveryPage.scss"
import 'react-day-picker/lib/style.css';


@observer
export default class DeliveryPage extends Component {

  state = {
    uploadedImages  : [],
    locations       : [],
    locationSelected: null,
    comment         : "",
    modalOpened     : false,
    tempAddressIndex: 0,
    tempAddress     : {
      mapid   : "0",
      name1   : "",
      name2   : "",
      name3   : "",
      street  : "",
      pcode   : "",
      city    : "",
      country : "",
      company : "",
      addition: "",
    }
  }

  handleAddressChoice = () => {
    const tempAddress = this.state.tempAddress
    const nextTempAddressIndex = this.state.tempAddressIndex + 1

    shop.cart.setAddress( { location: tempAddress } )

    this.setState( {
      locations       : [tempAddress, ...this.state.locations],
      locationSelected: tempAddress.mapid,
      modalOpened     : false,
      tempAddressIndex: nextTempAddressIndex,
      tempAddress     : {
        mapid   : `tempAddress${nextTempAddressIndex}`,
        company : "",
        name1   : "",
        name2   : "",
        name3   : "",
        street  : "",
        pcode   : "",
        city    : "",
        country : "",
        addition: "",
      }
    } )
  }

  toggleModal = ( toggle = false ) => {
    this.setState( { modalOpened: toggle } )
  }

  handleAddressFieldChange = ( evt ) => {
    const tempAddress = this.state.tempAddress
    tempAddress[ evt.target.name ] = evt.target.value
    this.setState( { tempAddress } )
  }

  handleLocationSelect = ( location ) => {
    console.log( `set`, location )
    this.setState( { locationSelected: location.mapid } )
    shop.cart.setAddress( { location } )
  }

  handleOrderIdChange = ( event ) => {
    let manual_order_id = event.target.value
    this.setState( { manual_order_id } )
    shop.cart.setExtra( "manual_order_id", manual_order_id )
  }

  handleCommentChange = ( event ) => {
    let comment = event.target.value
    this.setState( { comment } )
    shop.cart.setComment( { comment } )
  }

  handleDateChange = ( date ) => {
    let deliverdate = moment( date )
    if ( deliverdate.isValid() ) {
      deliverdate = deliverdate.format( "DD.MM.YYYY" )
      this.setState( { deliverdate } )
      shop.cart.setDeliverdate( { deliverdate } )
    } else {
      shop.cart.setDeliverdate( ({ deliverdate: "" }) )
      this.setState( { deliverdate: "" } )
    }

  }

  updateCart = ( { cart } ) => {
    let locationSelected = cart.data.deliveraddress && cart.data.deliveraddress.mapid
    if ( locationSelected ) {
      this.setState( { locationSelected } )
    }
  }

  componentWillUnmount() {
    shop.cart.hooks.changed.remove( this.updateCart )
  }

  componentDidMount() {
    shop.cart.hooks.changed.add( this.updateCart )

    // let ok = checkCartSize()
    // ok = ok && checkMinCartValue()
    // if ( !ok ) return

    if ( shop.cart.data.deliveraddress && shop.cart.data.deliveraddress.mapid ) {
      let locationSelected = shop.cart.data.deliveraddress.mapid
      this.setState( { locationSelected } )
    }

    shop.fetch( "/shop/rest/data/customers/current/addresses/deliver" )
      .then( locations => {
        console.log( "LOCATIONS!", locations.length, { locations } )

        if ( locations.length < 1 ) {
          console.info( "Keine Versandadressen vorhanden" )
          return
        }

        let locationSelected = this.state.locationSelected
        console.log( `locationSelected`, locationSelected, locations.length )

        const shortlist = locations.slice( 0, 5 )

        this.setState( {
          locations,
          shortlist,
          locationSelected
        } )
      } )
  }

  render() {
    let { uploadedImages, locations, shortlist, locationSelected, tempAddress, modalOpened } = this.state
    const attachments = shop.cart.getExtra( "attachments" )
    const deliveryLocation = locations.filter( loc => loc.mapid === locationSelected )
    let { comment, deliveraddress, deliverdate, print_receipt, comment_internal } = shop.cart.data
    let { manual_order_id } = shop.cart.data.extras
    let billingAddress = shop.session.value || {}
    const { checkoutType } = this.props.match.params
    const isRequest = !!checkoutType
    const { hasDeliveryAddress } = shop.cart
    return (
      <div className="pb5">
        {/*HEADER STATE*/}
        {this.props.children}
        <HeaderCheckout activeStep={1} isRequest={isRequest}/>

        <section className="container">

          <div className="row-title tl">
            <h2>{translate( "your data" )}</h2>
          </div>
          <Row>

            <Col md="1/5" className=""><span className="black-50">{translate( "billing address" )}</span>
              <div className="pt3">
                <strong> {billingAddress.title}</strong> <br/>
                {billingAddress.street} <br/>
                {billingAddress.pcode} {billingAddress.city}<br/>
                {billingAddress.country}<br/>
              </div>
            </Col>
            <Col md="1/5" className=""><span className="black-50">{translate( "delivery address" )} </span>
              <div className="pt3">
                {!hasDeliveryAddress && <div className={"b"}>{translate( "billing address" )}</div>}
                {deliveraddress && <div>
                  <div className="mb4">
                    <strong>{deliveraddress.name1} {deliveraddress.name2} {deliveraddress.name3}</strong><br/>
                    {deliveraddress.street}<br/>
                    {deliveraddress.pcode} {deliveraddress.city}<br/>
                    {deliveraddress.country}<br/>
                  </div>
                </div>}
              </div>
            </Col>
            {/*<Col md="1/5" className=""><span className="black-50">{translate( "payment" )} </span>*/}
            {/*  <div className="pt3">*/}
            {/*    <strong>wie vereinbart</strong>*/}
            {/*  </div>*/}
            {/*</Col>*/}
            <Col md="1/5" className=""><span className="black-50">{translate( "your message" )}
              <div className="pt3">
                  <p className="mb4">{comment ? comment : "-"}</p>
              </div>
              </span></Col>
          </Row>

        </section>

        <section className="container pt4 pb4">
          <div className="row-title tl">
            <h2>{translate( "your addresses" )}</h2>
          </div>
          {locations.length > 10 ? <div>
            <Adresses onChange={this.handleLocationSelect}
                      locations={shortlist}
                      deliveryLocation={deliveryLocation}
                      locationSelected={locationSelected}/>
            <div><Link to="/checkout/delivery/addresses">Zeige 5 von {locations.length} Adressen an</Link>
            </div>
          </div> : <Adresses onChange={this.handleLocationSelect}
                             locations={locations}
                             locationSelected={locationSelected}/>
          }

        </section>


        <section className="container">
          <Row>
            <Col sm="2/3">
              <FormField label={translate( "comment" )}
                         htmlFor="supported-controls-input">
                <FormInput placeholder={translate( "comment" )}
                           value={comment}
                           onChange={this.handleCommentChange}
                           multiline/>
              </FormField>
            </Col>
          </Row>
        </section>


        {shop.config.checkoutFeatures.manualOrderId &&
        <section className="container">
          <div className="mw6">

            <FormField label={translate( "order number" )}>
              <FormInput placeholder={translate( "order number" )}
                         value={manual_order_id}
                         onChange={this.handleOrderIdChange}
              />
            </FormField>

          </div>
        </section>
        }


        {/*DELIVERY DATE SUGGESTION*/}
        {(shop.config.checkoutFeatures.deliverdate || shop.config.plugin.deliverdate) &&
        <section className="container">
          {/*COMMENT WITH UPLOAD */}
          {/*NORMAL COMMENT*/}

          <Row>
            <Col sm="2/3">
              <FormField label={translate( "delivery after" )}
                         htmlFor="supported-controls-input">
                <DeliveryDatePicker date={deliverdate} onChange={this.handleDateChange}/>
              </FormField>
            </Col>
          </Row>
        </section>
        }


        {/*ONLY FOR VERTRIEBSACCOUNTS*/}
        {shop.session.handId && <div>
          <section className="container">
            <Header>{translate( "back office" )}</Header>
            <Row>
              {/*<Col sm="1/2">*/}
              {/*<FormField label={translate( "comment internal" )}*/}
              {/*htmlFor="supported-controls-input">*/}
              {/*<FormInput placeholder={translate( "comment" )}*/}
              {/*value={comment_internal}*/}
              {/*onChange={event => {*/}
              {/*let comment_internal = event.target.value*/}
              {/*shop.cart.setExtra( "comment_internal", comment_internal )*/}
              {/*}}*/}
              {/*multiline/>*/}
              {/*</FormField>*/}
              {/*</Col>*/}
              <Col sm="1/2">
                <FormField label={translate( "Belegausdruck/Innendienst" )}
                           htmlFor="supported-controls-input">
                  <FormInput placeholder={translate( "Belegausdruck/Innendienst" )}
                             value={print_receipt}
                             onChange={event => {
                               let print_receipt = event.target.value
                               shop.cart.setExtra( "print_receipt", print_receipt )
                             }}
                             multiline/>
                </FormField>
              </Col>
            </Row>
          </section>
        </div>}

        <section className="pa2 mb4 ">
          <div className="container">
            <Row>
              <Col xs="1/2"
                   className="tl fl checkout-control">
                <Link to={{pathname: "..", search: this.props.location.search}}>
                  <Button>
                    <i className="icon-angle-left"/>
                    {translate( "Zurück" )}
                  </Button>
                </Link>
              </Col>

              <Col xs="1/2"
                   className="tr fr checkout-control">
                <Link to={{
                  pathname: "../confirmation",
                  search: this.props.location.search
                }}>
                  <Button primary>
                    {translate( "Weiter" )}
                    <i className="icon-angle-right"/>
                  </Button>
                </Link>
              </Col>
            </Row>
          </div>
        </section>
      </div>
    )
  }
}

const Adress = ( { location, handleSelect, isSelected } ) => {
  return (
    <div>
      <h3>{location.mapid.indexOf( "tempAddress" ) !== -1 && "Eingegebene"} {translate( "Adresse" )}</h3>
      {location.company} <br/>
      {location.name1} {location.name2} {location.name3}<br/>
      {location.street} <br/>
      {location.addition} <br/>
      {location.pcode} {location.city}<br/>
      {location.country}<br/>
      <div className="pt3">
        {isSelected ?
          <Button primary onClick={() => handleSelect( false )} icon={"check"}/> :
          <Button size="small" basic onClick={() => handleSelect( location )}>{translate( "auswählen" )}</Button>
        }
      </div>
      {/*<pre>{JSON.stringify(location, null, 2)}</pre>*/}
    </div>
  )
}

const Adresses = ( { locations, locationSelected, onChange, deliveryLocation } ) => {
  let addresses = locations.map( ( location, key ) => {
    // console.log( `${locationSelected} == ${location.mapid}` )
    let isSelected = locationSelected == location.mapid
    if ( isSelected && deliveryLocation && deliveryLocation.mapid ) return null
    return (<Col key={key} sm="1/3"><Card>
      <Adress isSelected={isSelected} handleSelect={onChange} location={location}/></Card>
    </Col>)
  } )
  return <Row>
    {deliveryLocation && deliveryLocation.mapid && <Col key="AB" sm="1/3"><Card>
      <Adress isSelected={true} handleSelect={onChange} location={deliveryLocation}/></Card>
    </Col>}
    {addresses}</Row>
}


const TemporaryAddress = ( { handleModal, handleChange, handleAddressChoice, temporaryAddress, modalOpened } ) => {
  return (
    <div>
      <Modal isOpen={modalOpened} onCancel={() => handleModal( false )} backdropClosesModal>
        <ModalHeader text={`Neue Adresse hinzufügen`} onClose={() => handleModal( false )}/>
        <ModalBody>
          <TemporaryAddressForm handleChange={handleChange} temporaryAddress={temporaryAddress}/>
        </ModalBody>
        <ModalFooter>
          <Button type="link-cancel" onClick={() => handleModal( false )}>schließen</Button>
          <Button className="fr" type="primary" onClick={() => handleAddressChoice()}>hinzufügen</Button>
        </ModalFooter>
      </Modal>

      <Row>
        <Col sm="1">
          <Button className="mt2" onClick={() => handleModal( true )}>temporäre Adresse hinzufügen</Button>
        </Col>
      </Row>
    </div>
  )
}

const TemporaryAddressForm = ( { temporaryAddress, handleChange } ) => {
  return (
    <form>
      <Row>
        <Col sm="1/3">
          <FormField label="Anrede" htmlFor="name1">
            <FormSelect
              firstOption=" "
              name="name1"
              options={[
                { label: "Herr", value: "Herr" },
                { label: "Frau", value: "Frau" }
              ]} onChange={( value ) => {
              let fakeEvent = { target: { name: "name1", value } }
              handleChange( fakeEvent )
            }}/>
          </FormField>
        </Col>
        <Col sm="1/3">
          <FormField label="Vorname" htmlFor="name2">
            <FormInput type="text" name="name2" value={temporaryAddress.name2} onChange={handleChange}/>
          </FormField>

        </Col>
        <Col sm="1/3">
          <FormField label="Nachname" htmlFor="name3">
            <FormInput type="text" name="name3" value={temporaryAddress.name3} onChange={handleChange}/>
          </FormField>
        </Col>
      </Row>

      <FormField label="Firma" htmlFor="company">
        <Row>
          <Col sm="1">
            <FormInput type="text" name="company" placeholder="Firma" value={temporaryAddress.company}
                       onChange={handleChange}/>
          </Col>
        </Row>
      </FormField>

      <Row>
        <Col sm="1">
          <FormField label="Straße" htmlFor="street">
            <FormInput type="text" name="street" placeholder="Straße" value={temporaryAddress.street}
                       onChange={handleChange}/>
          </FormField>
        </Col>
      </Row>

      <Row>
        <Col sm="1">
          <FormField label="Adresszusatz" htmlFor="addition">
            <FormInput type="text" name="addition" placeholder="Adresszusatz"
                       value={temporaryAddress.addition}
                       onChange={handleChange}/>
          </FormField>
        </Col>
      </Row>

      <Row>
        <Col sm="1/5">
          <FormField label="PLZ" htmlFor="pcode">
            <FormInput type="text" name="pcode" placeholder="PLZ" value={temporaryAddress.pcode}
                       onChange={handleChange}/>
          </FormField>
        </Col>
        <Col sm="4/5">
          <FormField label="Ort" htmlFor="city">
            <FormInput type="text" name="city" placeholder="Ort" value={temporaryAddress.city}
                       onChange={handleChange}/>
          </FormField>
        </Col>
      </Row>

      <FormField label="Land" htmlFor="country">
        <Row>
          <Col sm="1">
            <FormInput type="text" name="country" placeholder="Land" value={temporaryAddress.country}
                       onChange={handleChange}/>
          </Col>
        </Row>
      </FormField>
    </form>
  )
}



// WEBPACK FOOTER //
// ./src/pages/checkout/DeliveryPage.js